<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
            type="primary"
            plain
            size="mini"
            icon="el-icon-circle-plus-outline"
            @click="addClick"
          >
            新增
          </el-button>
          <el-button
            type="danger"
            plain
            size="mini"
            icon="el-icon-circle-close"
            :disabled="tableData.length == 0"
            @click="delClick('all', ids)"
          >
            删除
          </el-button>
          <el-button
            type="primary"
            plain
            size="mini"
            icon="el-icon-top-right"
            @click="downloadHomeVisits"
            :disabled="tableData.length == 0"
          >
            导出
          </el-button>
      </div>
      <div class="search_box">
        <el-input
            placeholder="请输入学生姓名"
            size="mini"
            clearable
            class="textInput select-input"
            v-model.trim="searchParams.studentName"
          ></el-input
          >&nbsp;
          <el-input
            placeholder="请输入老师姓名"
            size="mini"
            clearable
            class="textInput select-input"
            v-model.trim="searchParams.terName"
          ></el-input
          >&nbsp;
          <el-date-picker
            class="select-picker"
            v-model="searchParams.time"
            size="mini"
            type="daterange"
            align="right"
            clearable
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker
          >&nbsp;
          <el-select
            class="select-input"
            v-model="searchParams.visitStatus"
            placeholder="家访状态"
            clearable
            size="mini"
          >
            <el-option
              v-for="(value, key) in $store.state.select.homeVisitStatus"
              :key="key"
              :label="value.nameOne"
              :value="value.id"
            ></el-option> </el-select
          >&nbsp;
          <el-button
            size="mini"
            type="primary"
            plain
            icon="el-icon-search"
            @click="searchData"
            >搜索</el-button
          >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="selectActionData"
        >
          <el-table-column type="selection" width="40" align="center">
          </el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{
                searchParams.pageSize * (searchParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="studentName"
            label="学生姓名"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="className"
            label="老师名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="name4"
            label="家访类型"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ $store.state.select.homeVisitType[scope.row.visitType].nameOne }}
            </template>
          </el-table-column>
          <el-table-column
            prop="name3"
            label="家访状态"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ $store.state.select.homeVisitStatus[scope.row.visitStatus].nameOne }}
            </template>
          </el-table-column>
          <el-table-column
            prop="name3"
            label="学生类型"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ $store.state.select.studentTypeList[scope.row.studentType].nameOne }}
            </template>
          </el-table-column>
          <el-table-column
            prop="visitTime"
            label="家访时间段"
            width="200px"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="teacherName"
            label="家访老师姓名"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="teacherPhone"
            label="老师联系电话"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="editClick(scope.row)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="delClick('single', [scope.row.id])"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchParams.pageNum"
          :page-size="searchParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <add-or-edit
      :drawerShow="drawerShow"
      :drawerType="drawerType"
      @handleClose="handleClose"
      @saveData="saveData"
      :initialData="addOrEditData"
    ></add-or-edit>
  </div>
</template>

<script>
import AddOrEditVisit from "./components/AddOrEditVisit";
export default {
  name: "",
  components: {
    "add-or-edit": AddOrEditVisit
  },
  props: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      searchParams: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1,
        studentName: "", //学生姓名
        terName: "", //老师名称
        time: [],
        visitTime: "", //家访时间段
        visitStatus: "" //家访状态 0待处理 1已完成
      },
      tableData: [],
      total: 0,
      ids: [],
      tableLoading: false,
      drawerShow: false,
      drawerType: "add",
      addOrEditData: {
        id: "", //id
        schoolId: this.$store.state.schoolId, //学校id
        studentName: "", //学生姓名
        className: "", //班级名称
        visitType: 0, //家访类型 0电话沟通 1到家家访
        visitStatus: 0, //家访状态 0待处理 1已完成（编辑时可以传）
        studentType: 0, //学生类型 0普通学生 1留守儿童学生 2特殊体质学生
        parentName: "", //家长姓名
        parentPhone: "", //家长联系方式
        address: "", //家庭地址
        time: [],
        visitTime: "", //家访时间段（例子2020-11-13 ~ 2020-11-13）
        teacherName: "", //家访老师姓名
        teacherPhone: "", //老师联系电话
        studentContent: "", //学生基本情况 (学业、品质、特长、家庭等)
        visitContent: "" //家访内容
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 搜索
    searchData() {
      this.searchParams.pageNum = 1;
      this.getList();
    },
    // 获取学生心里健康档案信息列表
    async getList() {
      this.tableLoading = true;
      let req = Object.assign({}, this.searchParams);
      if (req.time) {
        req.visitTime = req.time.join(" ~ ");
        delete req.time;
      }
      if (req.studentName == "") {
        delete req.studentName;
      }
      if (req.terName == "") {
        delete req.terName;
      }
      if (req.visitTime == "") {
        delete req.visitTime;
      }
      let res = await this.$Http.getHomeVisitsList(req);
      this.tableLoading = false;
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    // 新增
    addClick() {
      this.drawerShow = true;
      this.drawerType = "add";
    },
    // 修改
    editClick(row) {
      let self = this;
      if (row.id) {
        self.getInfo(row.id, function(type, val) {
          if (type) {
            self.addOrEditData = val;
            self.drawerShow = true;
            self.drawerType = "edit";
          }
        });
      } else {
        self.$message({
          message: "当前家访信息存在异常，请联系管理员!"
        });
      }
    },
    //   获取详情
    async getInfo(id, callback) {
      let res = await this.$Http.getHomeVisitsInfo({ id: id });
      if (res.code == 200) {
        let data = res.data;
        data.time = data.visitTime.split(" ~ ");
        data.schoolId = this.$store.state.schoolId;
        callback(true, data);
      } else {
        callback(false, {});
        this.$message({
          message: "详情获取失败，请刷新或联系管理员",
          type: "error"
        });
      }
    },
    // 关闭抽屉
    handleClose() {
      this.drawerShow = false;
      this.refearshData();
    },
    // 初始化新增或修改数据
    refearshData() {
      this.addOrEditData = {
        id: "", //id
        schoolId: this.$store.state.schoolId, //学校id
        studentName: "", //学生姓名
        className: "", //班级名称
        visitType: 0, //家访类型 0电话沟通 1到家家访
        visitStatus: 0, //家访状态 0待处理 1已完成（编辑时可以传）
        studentType: 0, //学生类型 0普通学生 1留守儿童学生 2特殊体质学生
        parentName: "", //家长姓名
        parentPhone: "", //家长联系方式
        address: "", //家庭地址
        time: [],
        visitTime: "", //家访时间段（例子2020-11-13 ~ 2020-11-13）
        teacherName: "", //家访老师姓名
        teacherPhone: "", //老师联系电话
        studentContent: "", //学生基本情况 (学业、品质、特长、家庭等)
        visitContent: "" //家访内容
      };
    },
    // 提交数据(新增或修改)
    saveData() {
      this.drawerShow = false;
      this.getList();
      this.refearshData();
    },
    selectActionData(selectData) {
      this.ids = selectData.map((item) => {
        return item.id;
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchParams.pageNum = val || 1;
      this.getList();
    },
    delClick(type, ids) {
      if (type == "all") {
        if (ids.length > 0) {
          this.deleteConfirm(ids);
        } else {
          this.$message({
            message: "请先选择所要删除的家访信息!"
          });
        }
      } else {
        this.deleteConfirm(ids);
      }
    },
    // 删除提示框
    deleteConfirm(ids) {
      this.$confirm("此操作将永久删除家访信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delHomeVisits({ ids: ids.toString() });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async delHomeVisits(data) {
      let req = Object.assign({}, data);
      let res = await this.$Http.delHomeVisits(req);
      if (res.code == 200) {
        this.getList();
      } else {
        this.$message({ type: "error", message: res.message || "删除失败" });
      }
    },
    // 导出定期家访信息
    async downloadHomeVisits() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      this.$Common.exportData(req, "downloadHomeVisits", "定期家访信息", false);
    }
  },
  created() {},
  mounted() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.select-input {
  width: 152px;
}
.select-picker {
  width: 340px;
}
</style>
